import { SET_MESSAGE, CLEAR_MESSAGE } from "./types";
import RestService from "../services/rest.service";
import planning from "../services/planning.service";


export const updatePlanning = (planning) => (dispatch) => {


    // mapping data
    dispatch({
        type: "SET_PLANNING",
        payload: planning,
    });
    return Promise.resolve();
    // return RestService.get('Planning_CarryScore').then(
    //     (response) => {
    //         // mapping data
    //         dispatch({
    //             type: "SET_CARRY_SCORE",
    //             payload: response.data,
    //         });
    //         return Promise.resolve(response.data);
    //     },
    //     (error) => {
    //         const message =
    //             (error.response &&
    //                 error.response.data &&
    //                 error.response.data.message) ||
    //             error.message ||
    //             error.toString();
    //         dispatch({
    //             type: "REGISTER_FAIL",
    //         });
    //         dispatch({
    //             type: "SET_MESSAGE",
    //             payload: message,
    //         });
    //         return Promise.reject();
    //     }
    // );
};
export const fetchPlanning = (id) => (dispatch) => {
    return planning.planning(id).then(
        (response) => {
            dispatch({
                type: "SET_PLANNING",
                payload: response?.data !== undefined ? response?.data : [],
            });
            return Promise.resolve(response);
        }
    );
};


export const getCarryScore = () => (dispatch) => {
    const mockData = require("../../src/data/db.json")
    // mapping data
    dispatch({
        type: "PLANNING_SET_CARRY_SCORE",
        payload: mockData.Planning_CarryScore,
    });
    return Promise.resolve();
    // return RestService.get('Planning_CarryScore').then(
    //     (response) => {
    //         // dispatch({
    //         //   type: "REGISTER_SUCCESS",
    //         // });
    //         dispatch({
    //             type: "PLANNING_SET_CARRY_SCORE",
    //             payload: mockData.Planning_CarryScore,
    //         });
    //         return Promise.resolve();
    //     },
    //     (error) => {
    //         const message =
    //             (error.response &&
    //                 error.response.data &&
    //                 error.response.data.message) ||
    //             error.message ||
    //             error.toString();
    //         dispatch({
    //             type: "REGISTER_FAIL",
    //         });
    //         dispatch({
    //             type: "SET_MESSAGE",
    //             payload: message,
    //         });
    //         return Promise.reject();
    //     }
    // );
};
